import { AxiosPromise } from "axios";
import configs from "../configs";
import { ApiGatewayLiveApi } from "./live/ApiGatewayLiveApi";

export class ApiGatewayApis {
    private static api: ApiGatewayLiveApi = new ApiGatewayLiveApi();

    // ==================== HEALTH & SYSTEM ====================

    static getHealth(): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getHealth();
    }

    static getSystemHealth(): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getSystemHealth();
    }

    static getSystemStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getSystemStats();
    }

    // ==================== PARTNER MANAGEMENT ====================

    static getAllPartners(page: number, perPage: number, query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAllPartners(page, perPage, query);
    }

    static getSinglePartner(id: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getSinglePartner(id);
    }

    static createPartner(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.createPartner(data);
    }

    static deleteRateAgreement(agreementId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.deleteRateAgreement(agreementId);
    }

    static updatePartner(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.updatePartner(id, data);
    }

    static approvePartner(id: number, data?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.approvePartner(id, data);
    }

    static rejectPartner(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.rejectPartner(id, data);
    }

    static suspendPartner(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.suspendPartner(id, data);
    }

    static reactivatePartner(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.reactivatePartner(id);
    }

    static creditWallet(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.creditWallet(id, data);
    }

    static debitWallet(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.debitWallet(id, data);
    }

    // ==================== API KEY MANAGEMENT ====================

    static getAllApiKeys(page: number, perPage: number, query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAllApiKeys(page, perPage, query);
    }

    static getSingleApiKey(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getSingleApiKey(id);
    }

    static createApiKey(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.createApiKey(data);
    }

    static revokeApiKey(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.revokeApiKey(id);
    }

    static rotateApiKey(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.rotateApiKey(id);
    }

    static approveCustomerAccess(userId: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.approveCustomerAccess(userId);
    }

    static rejectCustomerAccess(userId: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.rejectCustomerAccess(userId);
    }

    // ==================== PARTNER BILLING ====================

    static getPartnerRateAgreements(partnerId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getPartnerRateAgreements(partnerId);
    }

    static createPartnerRateAgreement(partnerId: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.createPartnerRateAgreement(partnerId, data);
    }

    static updateRateAgreement(agreementId: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.updateRateAgreement(agreementId, data);
    }

    static getAllInvoices(page: number, query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAllInvoices(page, query);
    }

    static getPartnerInvoices(partnerId: any, status?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getPartnerInvoices(partnerId, status);
    }

    static getInvoiceDetail(invoiceId: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getInvoiceDetail(invoiceId);
    }

    static generatePartnerInvoice(partnerId: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.generatePartnerInvoice(partnerId, data);
    }

    static updateInvoiceStatus(invoiceId: any, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.updateInvoiceStatus(invoiceId, data);
    }


    // ==================== ANALYTICS ====================

    static getAnalyticsOverview(period: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAnalyticsOverview(period);
    }

    static getAnalyticsRequests(period: number, source?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAnalyticsRequests(period, source);
    }

    static getTopConsumers(period: number, limit: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getTopConsumers(period, limit);
    }

    static getRecentErrors(hours: number, limit: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getRecentErrors(hours, limit);
    }

    // ==================== CRON TASKS ====================

    static runCronTask(task: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.runCronTask(task);
    }

    static runAllCronTasks(): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.runAllCronTasks();
    }

    // ==================== PARTNER MARKUP ====================

    static setPartnerMarkup(partnerId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.setPartnerMarkup(partnerId, data);
    }

    // ==================== PORTAL ACCOUNT MANAGEMENT ====================

    static getAllPortalAccounts(page: number, perPage: number, query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getAllPortalAccounts(page, perPage, query);
    }

    static getSinglePortalAccount(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.getSinglePortalAccount(id);
    }

    static approvePortalAccount(id: number, data?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.approvePortalAccount(id, data);
    }

    static rejectPortalAccount(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.rejectPortalAccount(id, data);
    }

    static deletePortalAccount(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") return {} as AxiosPromise;
        return this.api.deletePortalAccount(id);
    }
}